import { TreeFormIcon } from './TreeFormIcon';

export const OtherIcons: TreeFormIcon[] = ['file', 'folder', 'dashboard', 'lora', 'logger'];
